import { atom } from "jotai";
import UserPublicationFavoriteRecord from "models/view-models/user-publication-favorite-record";

const FavoritePublicationsAtom = atom<Array<UserPublicationFavoriteRecord>>([]);

export default FavoritePublicationsAtom;
